import { Box, Grid } from "@mui/material";
import { useState } from "react";
import { MentionsInput, Mention } from "react-mentions";
import { useSelector } from "react-redux";
import HelpIcon from "@mui/icons-material/Help";
import { useTranslation } from "react-i18next";

// export function swapTags(text) {
//   let displayText = _clone(text);
//   const tags = text.match(/@\{\{[^\}]+\}\}/gi) || [];
//   tags.map((myTag) => {
//     const tagData = myTag.slice(3, -2);
//     const tagDataArray = tagData.split("||");
//     const tagDisplayValue = tagDataArray[2];
//     displayText = displayText.replace(
//       new RegExp(_escapeRegExp(myTag), "gi"),
//       tagDisplayValue
//     );
//   });
//   return displayText;
// }

const Formula = ({
  setFormula,
  formula = "",
  helperTextFormula,
  setHelperTextFormula,
  setHelperUseFormula,
}) => {
  const { t } = useTranslation();
  const [stateMentions, setStateMentions] = useState({
    mentionData: null,
  });
  const options = useSelector(({ columns }) => columns?.listColumns?.data);
  const result = [];
  options.forEach((item) => {
    if ((item.data_type === 2 || item.data_type === 4) && !item.is_default)
      result.push(item);
  });
  const formulaMentionData = result.map((formula) => ({
    id: formula.id,
    display: formula.name,
    formula,
  }));

  const handleChange = (event, newValue, newPlainTextValue, mentions) => {
    setHelperTextFormula(undefined);
    setFormula(newValue);
    setStateMentions({
      mentionData: { newValue, newPlainTextValue, mentions },
    });
  };

  const getField = (display) => {
    return result.filter((e) => e.id === display)?.[0]?.name ?? display;
  };

  return (
    <Box
      sx={{
        "& .mentions__control": {
          // padding: "18.5px 14px",
          paddingLeft: "0px",
        },
        "& .mentions__input": {
          width: "100% !important",
          padding: "18.5px 14px",
          paddingRight: "37px",
          paddingLeft: "50px",
          borderRadius: "3px",
          border: "1px solid #c4c4c4",
        },
        "& .mentions__input:focus": {
          border: "1px solid #0078F3 !important",
        },
        "& .mentions__suggestions": {
          position: "relative !important",
          width: "100%",
          marginTop: "0px !important",
          transform: "translateY(-26px)",
        },
        "& .mentions__highlighter": {
          padding: "18.5px 14px",
          paddingRight: "37px",
          paddingLeft: "50px",
          transform: "translateY(-3px)",
        },
        // "& .mentions__highlighter__substring": {
        //   color: "black",
        //   visibility: "unset !important",
        // },
        "& .mentions__mention": {
          background: "#E4E6EB",
          borderRadius: "7px",
          padding: "7px 0px",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            color: "#9C9FA2",
            position: "absolute",
            left: "10px",
            top: "10px",
            fontSize: "20px",
          }}
        >
          Fx=
        </Box>
        <MentionsInput
          value={formula ?? ""}
          onChange={handleChange}
          placeholder={t("CREATE_COLUMN_FIELD.FORMULA_COL.FORMULA")}
          className="mentions"
          singleLine
          customSuggestionsContainer={(children) => {
            const css = {
              fontWeight: "bold",
              fontSize: "14px",
              padding: "7px 10px",
            };
            return (
              <Box
                sx={{
                  borderRadius: "12px",
                  boxShadow: "1px 2px #a799995c",
                  padding: "10px 0px",
                }}
              >
                <Grid container>
                  <Grid item xs={6} sx={css}>
                    {t("FIELDS")}
                  </Grid>
                  <Grid item xs={3} sx={css}>
                    {t("FORMAT")}
                  </Grid>
                  <Grid item xs={3} sx={css}>
                    {t("UNIT")}
                  </Grid>
                </Grid>
                {children}
              </Box>
            );
          }}
        >
          <Mention
            trigger="#"
            markup="{{__id__}}"
            data={formulaMentionData}
            className="mentions__mention"
            appendSpaceOnAdd={true}
            displayTransform={(id, display) => {
              return `  #${getField(display)}  `;
            }}
            renderSuggestion={(
              suggestion,
              search,
              highlightedDisplay,
              index,
              focused
            ) => {
              const css = {
                fontSize: "14px",
                padding: "10px",
              };
              return (
                <Grid
                  container
                  sx={{
                    "&:hover": {
                      background: "#F1F5FA",
                    },
                    border: "1px solid #F5F5F5",
                  }}
                >
                  <Grid item xs={6} sx={css}>
                    {suggestion?.formula?.name}
                  </Grid>
                  <Grid item xs={3} sx={css}>
                    {suggestion?.formula?.data_type === 2 && "Con số"}
                    {suggestion?.formula?.data_type === 4 && "Công thức"}
                  </Grid>
                  <Grid item xs={3} sx={css}>
                    {suggestion?.formula?.format ?? ""}
                  </Grid>
                </Grid>
              );
            }}
          />
        </MentionsInput>
        <HelpIcon
          sx={{
            fill: "#9C9FA2",
            position: "absolute",
            right: "10px",
            top: "14px",
            fontSize: "24px",
          }}
          onClick={() => {
            setHelperUseFormula(true);
          }}
        />
      </Box>
      {helperTextFormula && (
        <span style={{ color: "red" }}>{helperTextFormula}</span>
      )}
    </Box>
  );
};

export default Formula;
